import React from 'react';
import { connect } from 'react-redux';
import { Button, Col, message, Row, Upload } from 'antd';

import Category from '../components/category';
import AddMainCategoryButton from '../components/category/add-main-category-button';

import { getAllCategories } from '../components/category/actions';

import {
	API_ENDPOINT
} from '../index';

class CategoryPage extends React.Component{
	
	render(){

		const { categoryId } = this.props.match.params


		return (

			<div style={{padding: 10}}>

				<Row style={{paddingBottom: 10}} gutter={8} align="middle" justify="space-between" type="flex">
					<Col>

						<Row type="flex" gutter={8}>
							<Col>
								<h3>Category Page</h3>
							</Col>
							<Col>
								<AddMainCategoryButton />
							</Col>
						</Row>

					</Col>

					<Col>
						<Row gutter={8} type="flex">
							<Col>
								<Button target="dl-xlsx" href={`${API_ENDPOINT}/api/admin/category/xlsx`}>Download XLSX 4 Editing</Button>
							</Col>
							<Col>
								<Upload name="categories"
										action={`${API_ENDPOINT}/api/admin/category/xlsx`}
										onChange={ this.handleOnChangeUploadStatus }
										showUploadList={false}
										withCredentials={true}
										>
									<Button>Upload XLSX</Button>
								</Upload>
							</Col>
							<Col>
								<Button type="primary" onClick={ this.refresh } shape="circle" icon="reload" />
							</Col>
						</Row>
					</Col>
				</Row>
			
				{
					!this.state.refresh && <Category />
				}
	
			</div>
		)
	}

	state = {
		refresh: false
	}

	handleOnChangeUploadStatus = (info) => {
		if (info.file.status !== 'uploading') {
			console.log(info.file, info.fileList);
		}
		if (info.file.status === 'done') {
			message.success(`${info.file.name} file uploaded successfully`);
		} else if (info.file.status === 'error') {
			// console.log( info.response.data );
			message.error(`${info.file.name} file upload failed.`);
			message.error( info.file.response )
		}
	}

	refresh = () => {
		this.setState({
			refresh: true
		}, () => {
			setTimeout(() => {
				this.setState({
					refresh: false
				})
			}, 100);
		})
	}
}

export default connect(
	state => ({}),
	dispatchEvent => ({
		getAllCategories: () => dispatchEvent( getAllCategories() )
 	})
)(CategoryPage);


// WEBPACK FOOTER //
// ./src/containers/category-page.js